import { cs2Constants } from '../_constants';

export function cs2FileLog(state = {}, action) {
	
	console.log("action.type: " + action.type);
    switch (action.type) {
        case cs2Constants.SUBMISSION_LOG_REQUEST:
        	return {
        		loading: true
        	};
        case cs2Constants.SUBMISSION_LOG_SUCCESS:
        	return {
        		items: action.submissionLog.result
        	};
        case cs2Constants.SUBMISSION_LOG_FAILURE: 
        	return {
        		error: action.error
        	};
     	default:
            return state
    }
}